export default {
  get: {
    funKey: 'get',
    name: '查看',
    apis: [{
      path: '/basis/operation_log',
      method: 'GET'
    }]
  }
}